import { Clock, MapPin, Phone, Instagram, MessageCircle, ArrowUpRight } from "lucide-react";
import { track } from "@/lib/track";

const tid = (name) => name.toLowerCase().replace(/\s+/g, "-");

export default function StoreCard({ store }) {
  return (
    <article
      data-testid={`store-card-${tid(store.name)}`}
      className="flex h-full flex-col rounded-3xl border border-cream-line bg-white p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_24px_50px_-28px_rgba(7,61,43,0.35)] md:p-8"
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <h3 className="font-display text-2xl font-bold tracking-[-0.01em] text-deep">{store.name}</h3>
          <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.2em] text-orange-rific">{store.city}</p>
        </div>
        {store.coming_soon && (
          <span data-testid={`store-coming-soon-${tid(store.name)}`} className="rounded-full bg-fresh/15 px-3 py-1 font-mono text-[10px] font-medium uppercase tracking-[0.16em] text-fresh">
            Coming Soon
          </span>
        )}
      </div>

      <p className="mt-4 flex items-start gap-2 text-base leading-relaxed text-deep/75">
        <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-orange-rific" />
        {store.address}
      </p>
      {store.hours && (
        <p className="mt-2 flex items-start gap-2 text-base text-deep/75">
          <Clock className="mt-0.5 h-4 w-4 shrink-0 text-orange-rific" />
          {store.hours}
        </p>
      )}

      <div className="mt-auto flex flex-wrap gap-2 pt-6">
        {store.phone && (
          <a
            href={`tel:${store.phone.replace(/\s/g, "")}`}
            data-testid={`store-phone-${tid(store.name)}`}
            onClick={() => track("phone_click", { store: store.name, placement: "store_card" })}
            className="inline-flex items-center gap-1.5 rounded-full border border-deep/15 px-4 py-2.5 text-xs font-semibold uppercase tracking-[0.12em] text-deep transition-colors hover:border-orange-rific hover:text-orange-rific"
          >
            <Phone className="h-3.5 w-3.5" /> Call Store
          </a>
        )}
        <a
          href={`https://wa.me/${store.phone.replace(/\D/g, "")}`}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`store-whatsapp-${tid(store.name)}`}
          onClick={() => track("whatsapp_click", { store: store.name, placement: "store_card" })}
          className="inline-flex items-center gap-1.5 rounded-full border border-deep/15 px-4 py-2.5 text-xs font-semibold uppercase tracking-[0.12em] text-deep transition-colors hover:border-orange-rific hover:text-orange-rific"
        >
          <MessageCircle className="h-3.5 w-3.5" /> WhatsApp
        </a>
        {store.maps_url && (
          <a
            href={store.maps_url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`store-directions-${tid(store.name)}`}
            onClick={() => track("directions_click", { store: store.name })}
            className="inline-flex items-center gap-1.5 rounded-full bg-deep px-4 py-2.5 text-xs font-semibold uppercase tracking-[0.12em] text-cream transition-colors hover:bg-orange-rific"
          >
            Get Directions <ArrowUpRight className="h-3.5 w-3.5" />
          </a>
        )}
        {store.instagram && (
          <a
            href={store.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`store-instagram-${tid(store.name)}`}
            onClick={() => track("instagram_click", { store: store.name, placement: "store_card" })}
            className="inline-flex items-center gap-1.5 rounded-full border border-deep/15 px-4 py-2.5 text-xs font-semibold uppercase tracking-[0.12em] text-deep transition-colors hover:border-orange-rific hover:text-orange-rific"
          >
            <Instagram className="h-3.5 w-3.5" /> Instagram
          </a>
        )}
      </div>
    </article>
  );
}
